import { useMemo } from 'react';
import { trpc } from '@/api/trpc';
import { DEFAULT_REQUISITIES_STALE_TIME } from '@/config/constants';
import { useAppQuery, type AppQueryErrorConfig } from './useAppQuery';

/**
 * Shared query for trading requisites (strategies, profiles, option buying
 * strategies, etc.) with the app-standard retry and stale time. React Query
 * dedupes the request across any number of consumers.
 */
export const useTradingRequisites = (options?: { enabled?: boolean; errorConfig?: AppQueryErrorConfig }) => {
    const query = useAppQuery(
        {
            ...trpc.strategy.fetchTradingRequisites.queryOptions({}),
            enabled: options?.enabled,
            staleTime: DEFAULT_REQUISITIES_STALE_TIME
        },
        options?.errorConfig
    );

    const requisites = useMemo(() => query.data?.requisites, [query.data?.requisites]);

    return { error: query.error, isLoading: query.isLoading, query, requisites };
};
